package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.AuthRepository

class SendOnboardingInviteUseCase(
    private val authRepository: AuthRepository
) {
    /**
     * Creates the invitation; with an [email] the server sends it there (functions/index.js,
     * onInviteCreated - clients may not queue mail); returns the join code (the invitee types it in
     * "I have an invite code" after signing up, or opens https://evoshift.app/join?code=...).
     * @param invitedByManagerId - ID managera, który klika "Zaproś".
     * Jest potrzebne do metadanych (audit log), żeby wiedzieć kto zaprosił.
     */
    suspend operator fun invoke(
        email: String,
        workplaceName: String,
        workplaceId: String,
        invitedByManagerName: String,
        invitedByManagerId: String,
        targetShadowUserId: String
    ): Result<String> {
        return try {
            val joinCode = authRepository.createInvite(
                workplaceId = workplaceId,
                workplaceName = workplaceName,
                inviterId = invitedByManagerId,
                inviterName = invitedByManagerName,
                targetShadowUserId = targetShadowUserId,
                email = email.trim().takeIf { it.isNotEmpty() }
            ).getOrThrow()

            Result.success(joinCode)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}